const isLocal = window.location.hostname === "localhost";
const appOrigin = window.location.origin;

const clientId = process.env.REACT_APP_CLIENT_ID;
const tenantId = process.env.REACT_APP_TENANT_ID;

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: appOrigin,
    postLogoutRedirectUri: appOrigin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: [
    "User.Read",
    `api://${clientId}/access_as_user`,
  ],
};

export const API_BASE_URL = isLocal
  ? "http://localhost:7071/api"
  : "https://ic-employee-lifecycle-api.azurewebsites.net/api";

export const getApiToken = async (msalInstance) => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) return null;
  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes: [`api://${clientId}/access_as_user`],
      account: accounts[0],
    });
    return response.accessToken;
  } catch {
    // Silent failed (stale cache / consent needed) — redirect instead of popup.
    // Popup is unreliable: it opens localhost:3000 in a child window and never
    // closes if MSAL's popup handler doesn't run first. Redirect is the safe
    // fallback for enterprise SPAs.
    msalInstance.acquireTokenRedirect({
      scopes: [`api://${clientId}/access_as_user`],
      account: accounts[0],
    });
    return null;
  }
};
